import React from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { volteChartConfig } from '../chartConfigs';

/**
 * Props for the VolteEstablishmentEcharts component
 */
interface VolteEstablishmentEchartsProps {
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * VoLTE Establishment Success Rate Chart (LTE Site Level)
 * 
 * Displays aggregated Voice over LTE (VoLTE) establishment metrics across all cells in an LTE site:
 * - VoLTE Establishment Success (count)
 * - VoLTE Establishment Attempt (count)
 * - VoLTE Establishment Success Rate (percentage)
 * 
 * @component
 * @see {@link ../chartConfigs.ts} - Chart configuration (volteChartConfig)
 * @see {@link ../../../components/SiteCharts.tsx} - Template component
 * @see API: /api/lte/volte-establishment?site_name={siteName}
 */

const VolteEstablishmentEcharts: React.FC<VolteEstablishmentEchartsProps> = ({ 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  return (
    <SiteCharts 
      config={volteChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
    />
  );
};

export default VolteEstablishmentEcharts;
